import { Component, OnInit, Inject, inject } from "@angular/core";
import { StandardService } from "../services/standard.service";
import {
  StandardTypeEnum,
  UserRoleEnum,
  StandardListType,
} from "../core/constant";
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { CryptographyService } from "../services/cryptography.service";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { SelectedStandard } from "../models/selected-standard";
import { Attachment } from "../models/attachment";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import DOMPurify from "dompurify";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../snackbar/snackbar.component";

@Component({
  selector: "app-view-all-upcoming-equipment-detail-view",
  templateUrl: "./view-all-upcoming-equipment-detail-view.component.html",
  styleUrls: ["./view-all-upcoming-equipment-detail-view.component.scss"],
})
export class ViewAllUpcomingEquipmentDetailViewComponent implements OnInit {
  private _snackBar = inject(MatSnackBar);
  detailsExpanded: boolean = false;
  allLocations: string = "";
  subLocations: string = "";
  grsId: number;
  loading: boolean = false;
  grsDetail: SelectedStandard = new SelectedStandard();
  userRole: number;
  notes: SafeHtml;
  additionalInformation: SafeHtml = "";

  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  get userRoleEnum() {
    return UserRoleEnum;
  }

  get keyContactEmailResolved(): string {
    const d = this.grsDetail as any;
    return (
      d?.keyContact?.email ||
      d?.keyContact?.Email ||
      d?.standard?.keyContact?.email ||
      d?.standard?.keyContact?.Email ||
      d?.standard?.email ||
      d?.standard?.Email ||
      d?.email ||
      d?.Email ||
      (this as any).keyContactEmail ||
      ""
    );
  }

  get linksList(): any[] {
    const d = this.grsDetail as any;
    const rawLinks = d?.links || d?.standard?.links || d?.Links || d?.standard?.Links || d?.resourceLinks1 || [];
    if (!Array.isArray(rawLinks)) return [];
    return rawLinks.map((l: any) => ({
      url: l?.url || l?.Url || "",
      title: l?.title || l?.Title || l?.url || l?.Url || ""
    })).filter(l => !!l.url?.trim() || !!l.title?.trim());
  }

  get hardwareDescription(): string {
    const d = this.grsDetail as any;
    return (
      d?.keyContact?.emailDescription ||
      d?.keyContact?.EmailDescription ||
      d?.standard?.keyContact?.emailDescription ||
      d?.standard?.keyContact?.EmailDescription ||
      d?.standard?.emailDescription ||
      d?.standard?.EmailDescription ||
      d?.emailDescription ||
      d?.EmailDescription ||
      d?.keyContactDesc ||
      d?.standard?.keyContactDesc ||
      ""
    );
  }

  constructor(
    private router: Router,
    private standardService: StandardService,
    private cryptographyService: CryptographyService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private activeRoute: ActivatedRoute,
    private ngbModal: NgbModal,
    private sanitizer: DomSanitizer,
    private location: Location
  ) {
    this.grsId = parseInt(this.activeRoute.snapshot.paramMap.get("grsId"));
  }

  ngOnInit() {
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole")
    );
    this.getDetailByGrbesId(this.grsId);
  }

  getDetailByGrbesId(grsId: number) {
    this.loading = true;
    this.standardService
      .getGrbesDetailInfomationByStandardId(
        grsId,
        this.cryptographyService.decryptData(this.storage.get("countryId")),
        this.standardService.upcomingStandardFiltration.filterSet,
        StandardListType.Upcoming,
        null
      )
      .subscribe((data: SelectedStandard) => {
        this.grsDetail = new SelectedStandard(data);
        this.allLocations = this.grsDetail.standard.standardLocation.length > 0 ? this.grsDetail.standard.standardLocation.map((loc: any) => loc.locationType.name)
          .join(", ") : this.grsDetail.standard.locationType?.name || "";
        this.subLocations = this.grsDetail.standard.standardLocation
          .map((loc: any) =>
            loc.locationType.subLocationTypes?.length
              ? loc.locationType.subLocationTypes.map((sloc) => sloc.name).join(", ")
              : "",
          )
          .filter(Boolean)
          .join(", ");

        const cleanNote = DOMPurify.sanitize(this.grsDetail.standard.note);
        this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNote);

        const cleanAddInfo = DOMPurify.sanitize(
          this.grsDetail.standard.additionalInformation
        );
        this.additionalInformation =
          this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);

        this.loading = false;
      }, (error: any) => {
        this.loading = false;
      });
  }

  navigateAccToType(type, id) {
    if (type == 4) {
      this.router.navigate(["/minimum-standard-detail-view/" + id]);
      return;
    }
    if (type == 8) {
      this.router.navigate(["/operations-standards-detail-view/" + id]);
      return;
    }
    if (type == 0) {
      this.router.navigate(["/view-upcoming-equipments-standard-detail/" + id]);
      return;
    }
    if (type == 1 || type == 2) {
      this.router.navigate(["/global-recommendations-detail-view/" + id]);
      return;
    }
  }

  slide(grsID: number, isForward: boolean) {
    this.loading = true;
    this.standardService
      .getNextPreviousGrsInfomationByCurrentStandardId(
        grsID,
        isForward,
        this.cryptographyService.decryptData(this.storage.get("countryId")),
        this.standardService.upcomingStandardFiltration.filterSet,
        StandardListType.Upcoming
      )
      .subscribe((data: SelectedStandard) => {
        if (
          data.standard.standardTypeId !=
          this.standardTypeEnum.GlobalEquipmentStandard
        ) {
          this.router.navigate([
            "/view-upcoming-standard-detail/" + data.standard.id,
          ]);
        } else {
          this.router.navigate([
            "/view-upcoming-equipments-standard-detail/" + data.standard.id,
          ]);
        }
        this.grsDetail = new SelectedStandard(data);
        const cleanNote = DOMPurify.sanitize(this.grsDetail.standard.note);
        this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNote);
        const cleanAddInfo = DOMPurify.sanitize(
          this.grsDetail.standard.additionalInformation
        );
        this.additionalInformation =
          this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);

        this.loading = false;
      }, (err) => {
        this.loading = false;
      });
  }

  onDownloadSelectedEquipmentAttachment(e) {
    return this.standardService.getAttachmentUrl(e.id, false).subscribe(
      (response: any) => {
        const blob = new Blob([response], {
          type: response.type,
        });
        if (
          (window.navigator as any) &&
          (window.navigator as any).msSaveOrOpenBlob
        ) {
          (window.navigator as any).msSaveOrOpenBlob(blob, e.fileName);
          return;
        }
        var a = document.createElement("a");
        document.body.appendChild(a);

        let url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = e.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      (error: any) => {
        const modalRef = this.ngbModal.open(FailModuleComponent);
        modalRef.componentInstance.errorMessage = error.error
          ? error.error.Message
          : error.message;
      }
    );
  }

  downloadExcel() {
    this.standardService.downloadSingleStandardExcel(
      this.grsDetail,
      "equipment"
    );
  }

  isShareModalOpen = false;
  shareModalTitle = "";
  shareModalSubtitle = "";
  shareModalUrl = "";

  openShareModal(): void {
    const standard = (this.grsDetail as any)?.standard;
    this.shareModalTitle = standard?.title || "";
    this.shareModalSubtitle = [
      standard?.standardType?.name,
      standard?.category?.name,
    ]
      .filter(Boolean)
      .join(" · ");
    this.shareModalUrl = window.location.href;
    this.isShareModalOpen = true;
  }

  toggleDetails() {
    this.detailsExpanded = !this.detailsExpanded;
  }

  getDetails() {
    return this.sanitizer.bypassSecurityTrustHtml(
      (this.grsDetail.standard.note || "").replace(/\n/g, "<br>")
    );
  }

  openSnackBar() {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 2000,
      data: {
        message: "Object Copied to clipboard!",
      },
    });
  }

  copyText(content: any) {
    navigator.clipboard.writeText(content);
    this.openSnackBar();
  }

  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(["/view-all-upcoming-standards-list"]);
    }
  }
}
